<script lang="ts">
  import { getStageMeta, stageFromStatusName, type LifecycleStage } from '../lib/donationLifecycle';

  // Provide either a resolved lifecycle stage (preferred) or a raw status name.
  export let stage: LifecycleStage | null = null;
  export let statusName: string | null = null;
  export let showIcon: boolean = true;

  $: resolved = (stage ?? stageFromStatusName(statusName)) as LifecycleStage;
  $: meta = getStageMeta(resolved);
  // Tones that represent forward progress get a tick; waiting states a clock; rejected a cross.
  $: icon = meta.tone === 'red' ? 'cross' : (meta.tone === 'amber' || meta.tone === 'grey' ? 'clock' : 'check');
</script>

<span class="lc-badge {meta.badgeClass}">
  {#if showIcon}
    {#if icon === 'check'}
      <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/></svg>
    {:else if icon === 'cross'}
      <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/></svg>
    {:else}
      <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clip-rule="evenodd"/></svg>
    {/if}
  {/if}
  <span>{meta.label}</span>
</span>
